import React from 'react';
import { Icon, IconName } from 'app/common/components/controls';
import { forTemplate } from 'app/common/lib/util/i18n';
import styles from './ArchivedListBanner.less';

const format = forTemplate('card_detail');

export const ArchivedListBanner: React.FunctionComponent = () => {
  return (
    <div className={styles.archivedBanner}>
      <Icon
        name={IconName.Archive}
        className={styles.archiveBannerIcon}
        large
      />
      <p className={styles.archivedBannerText}>
        {format('this-card-is-in-an-archived-list')}
      </p>
    </div>
  );
};
